import { render } from "./ProfitLoss.vue?vue&type=template&id=746814dc&scoped=true"
import script from "./ProfitLoss.vue?vue&type=script&lang=js"
export * from "./ProfitLoss.vue?vue&type=script&lang=js"

import "./ProfitLoss.vue?vue&type=style&index=0&id=746814dc&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746814dc"]])

export default __exports__